<template>
  <div id="app">
    <transition name="overflow-fade">
      <div
        v-if="$root.ready && overflow"
        class="ready-overflow"
        @click="openWebsite()"
      >
        <div class="text-center w-100 absolute bottom-0" style="position: absolute; bottom: 0; padding-bottom: 2rem; margin-bottom: 1rem">
          <div class="title">The Wedding</div>
          <!-- <span>of</span> -->
          <div class="mb-4 name">
            {{ wedding.man.surname }} 
            <div style="margin-top: -1rem; margin-bottom: -1rem;">&</div> 
            {{ wedding.woman.surname }}
          </div>

          <div>
            <button
              class="text-uppercase btn btn-outline-primary"
              @click="openWebsite()"
            >
              Buka Undangan
            </button>
          </div>
        </div>
      </div>
    </transition>

    <AGWAudio
      :file="music.file"
      :loop="music.loop"
      :autoplay="music.autoplay"
      ref="audio"
    />
    <AGWHero
      overlay
      :images="backgrounds"
      ref="hero"
      parallax
      target="#intro"
    />

    <div
      class="bg-white agw-content"
      :style="{ 'margin-top': `${$root.hero.height}px` }"
    >
      <AGWIntro
        id="intro"
        style="position:relative; box-shadow: 0 5px 15px rgb(175 150 105 / 34%)"
      />

      <AGWPawiwahan id="pawiwahan" class="bg-blue-light py-5" />
      <AGWMepandes id="mepandes" class="pad-y-60" :mepandes="mepandes" />

      <AGWCounter
        id="counter"
        class="pad-y-60"
        :background="background"
        :date="time.start"
      />
      <AGWGallery id="gallery" class="py-5" />
      <AGWMap
        :height="450"
        :url="map"
        :directionUrl="direction"
        :location="location"
        id="map"
      />
    </div>

    <div class="agw-content" style="background: transparent">
      <Himbauan />
      <attendance id="attendance" class="pad-y-60"></attendance>
    </div>

    <FooterCeremonyku ref="footer" />

    <transition name="slide-fade">
      <guest-box :floating="true" />
    </transition>

    <div class="snackbar" v-if="sw.updateExists">
      New version available!
      <button @click="refreshApp" class="btn">REFRESH</button>
    </div>
  </div>
</template>

<script>
const ImageHero1 =
  "https://ik.imagekit.io/aryraditya/ceremonyku/juniarta-budayanti/_RAI0578-Edit.jpg?updatedAt=1632227881768&tr=w-1000";
const ImageHero2 =
  "https://ik.imagekit.io/aryraditya/ceremonyku/juniarta-budayanti/_RAI0599-Edit.jpg?updatedAt=1632227882652&tr=w-800";
// const ImageHero3 =
  // "https://ik.imagekit.io/crk/setiawa-gekayas/WP2_6076.jpg?updatedAt=1629558412758&tr=w-800";

import Audio from "@/assets/audio/soundtrack.mp3";

import AGWHero from "@/components/Hero/HeroTwo";
import AGWIntro from "@/components/Intro";
import AGWPawiwahan from "@/components/Pawiwahan";
import AGWMepandes from "@/components/Mepandes";
import AGWCounter from "@/components/Counter";
import AGWGallery from "@/components/Gallery/GalleryOne";
import AGWMap from "@/components/Maps";
import AGWAudio from "@/components/Audio";
import GuestBox from "@/components/GuestBox";
import Attendance from "@/components/Attendance";
import Himbauan from "./components/Himbauan.vue";
import FooterCeremonyku from "@/components/Footer/Sabali";

import { setInterval } from "timers";

const SESSION = [
  ['2021-10-08 10:00', 'Selesai'],
];

export default {
  name: "app",
  components: {
    AGWHero,
    AGWIntro,
    AGWPawiwahan,
    AGWMepandes,
    AGWCounter,
    AGWGallery,
    AGWMap,
    AGWAudio,
    GuestBox,
    Attendance,
    Himbauan,
    FooterCeremonyku,
  },
  data() {
    return {
      title: "Pawiwahan",
      backgrounds: [ImageHero1, ImageHero2],
      bgActive: 0,
      dividerHeight: 0,
      overflow: true,
      location: "Jl. Yudistira No.35 Br. Cabe, Darmasaba, Badung - Bali",
      map:
        "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3945.1563851428423!2d115.22691441478348!3d-8.580958393832452!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zOMKwMzQnNTEuNSJTIDExNcKwMTMnNDQuOCJF!5e0!3m2!1sen!2sid!4v1632227514808!5m2!1sen!2sid",
      direction:
        "https://www.google.com/maps?q=-8.580958366394043,115.2291030883789&z=17&hl=en",
      time: {
        start: this.$moment("2021-10-08 10:00"),
        end: "Selesai",
      },
      wedding: {
        man: {
          name: " I Gede Juniarta",
          surname: "Juniarta",
          parents: "I Wayan Suparta & Ni Kadek Tarini",
          description: "Putra pertama",
          address: "Br. Cabe Darmasaba",
          photo: "https://ik.imagekit.io/aryraditya/ceremonyku/juniarta-budayanti/_RAI0667-Edit.jpg?updatedAt=1632227885905&tr=w-553,h-690,fo-custom,cm-extract"
        },
        woman: {
          name: "Ns. Ni Made Budayanti, S. Kep",
          surname: "Budayanti",
          parents: "I Wayan Nukra & Ni Putu Merdawati",
          address: "Mumbul, Benoa",
          description: "Putri kedua",
          photo: "https://ik.imagekit.io/aryraditya/ceremonyku/juniarta-budayanti/_RAI0679-Edit.jpg?updatedAt=1632227886727&tr=w-640,h-801,fo-custom,cm-extract"
        },
      },
      mepandes: [
        {
          name: 'I Kadek Pery Gunawan',
          // image: 'https://ik.imagekit.io/ceremonyku/iyan-tini/SKP_4414e_XA6Xqi5UR_LiP.jpg?tr=w-671,h-671,fo-custom,cm-extract'
        },
        {
          name: 'I Kadek Rudi Sastrawan',
        },
      ],
      gallery: [],
      music: {
        file: Audio,
        autoplay: true,
        loop: true,
      },
      sw: {
        refreshing: false,
        registration: null,
        updateExists: false,
      },
    };
  },
  computed: {
    background() {
      return this.backgrounds[this.bgActive];
    },
    session() {
      const url = new URLSearchParams(window.location.search);
      const sesi = Number(url.get("sesi")) || 1;
      return sesi > SESSION.length ? 1 : sesi;
    }
  },
  mounted() {
    const [start, end] = SESSION[this.session - 1] || SESSION[0];

    this.time.start = this.$moment(start);
    this.time.end = end;

    this.dividerHeight = `calc(100vh - ${this.$refs.footer.offsetHeight}px)`;
    setInterval(() => {
      let active = this.bgActive + 1;
      if (active >= this.backgrounds.length) {
        active = 0;
      }

      this.bgActive = active;
    }, 5000);
  },
  created() {
    document.addEventListener("swUpdated", this.showRefreshUI, { once: true });
    if (navigator.serviceWorker) {
      navigator.serviceWorker.addEventListener("controllerchange", () => {
        if (this.sw.refreshing) return;
        this.sw.refreshing = true;
        window.location.reload();
      });
    }
  },
  methods: {
    showRefreshUI(e) {
      this.sw.registration = e.detail;
      this.sw.updateExists = true;
    },
    refreshApp() {
      this.sw.updateExists = false;
      if (!this.sw.registration || !this.sw.registration.waiting) {
        return;
      }
      this.sw.registration.waiting.postMessage("skipWaiting");
    },
    openWebsite() {
      this.overflow = false;
      document.querySelector("#loading").classList.remove("active");
      if (this.$refs.audio) this.$refs.audio.play();
    },
  },
};
</script>

<style lang="scss" scoped>
.overflow-fade-enter-active {
  transition: all 1s ease;
}
.overflow-fade-leave-active {
  transition: all 0.3s cubic-bezier(1, 0.5, 0.8, 1);
}
.overflow-fade-enter,
.overflow-fade-leave-to {
  opacity: 0;
}
</style>
